import { useState } from 'react';

const categories = [
  { id: 'all', name: '所有手遊', icon: 'ri-gamepad-line', count: 156 },
  { id: 'taiwan', name: '台灣手遊', icon: 'ri-map-pin-line', count: 42 },
  { id: 'china', name: '大陸手遊', icon: 'ri-china-railway-line', count: 68 },
  { id: 'korea', name: '韓國手遊', icon: 'ri-heart-line', count: 28 },
  { id: 'japan', name: '日本手遊', icon: 'ri-sword-line', count: 18 }
];

export default function CategoryTabs() {
  const [activeTab, setActiveTab] = useState('all');

  return (
    <div className="bg-white border-b border-gray-200 sticky top-0 z-40 shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center gap-2 overflow-x-auto py-4 scrollbar-hide">
          {categories.map((category) => (
            <button
              key={category.id}
              onClick={() => setActiveTab(category.id)}
              className={`group relative flex items-center gap-2 px-5 py-2.5 rounded-xl font-medium text-sm whitespace-nowrap transition-all duration-300 ${
                activeTab === category.id
                  ? 'bg-gradient-to-r from-blue-600 to-cyan-600 text-white shadow-lg shadow-blue-500/30 scale-105'
                  : 'bg-gray-50 text-gray-600 hover:bg-gray-100 hover:text-gray-800 hover:scale-105'
              }`}
            >
              {/* 圖標 */}
              <div className={`w-5 h-5 flex items-center justify-center transition-transform duration-300 ${
                activeTab === category.id ? 'scale-110' : 'group-hover:scale-110'
              }`}>
                <i className={`${category.icon} text-base`}></i>
              </div>

              {/* 名稱 */}
              <span>{category.name}</span>

              {/* 數量角標 */}
              <span className={`px-2 py-0.5 rounded-full text-xs font-semibold transition-all duration-300 ${
                activeTab === category.id
                  ? 'bg-white/20 text-white'
                  : 'bg-gray-200 text-gray-600 group-hover:bg-blue-100 group-hover:text-blue-600'
              }`}>
                {category.count}
              </span>

              {/* 激活狀態底部裝飾線 */}
              {activeTab === category.id && (
                <div className="absolute -bottom-4 left-1/2 -translate-x-1/2 w-8 h-1 bg-gradient-to-r from-blue-600 to-cyan-600 rounded-full"></div>
              )}

              {/* 懸停光暈效果 */}
              {activeTab === category.id && (
                <div className="absolute inset-0 bg-gradient-to-r from-blue-400 to-cyan-400 opacity-20 blur-xl rounded-xl animate-pulse"></div>
              )}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}